import { Component, OnInit } from '@angular/core';
import { Config } from '../app-constant';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { WebSocketService } from 'src/app/service/websocket/web-socket.service';

@Component({
  selector: 'app-auto-login',
  templateUrl: './auto-login.component.html',
  styleUrls: ['./auto-login.component.scss']
})
export class AutoLoginComponent implements OnInit {
  fiscalYear: any;

  constructor(
    private httpService: HttpService,
    private config: Config,
    private route: ActivatedRoute,
    private router: Router,
    private encryptionService: EncryptionService,
    private WebSocketServices: WebSocketService
  ) {}
  userRole: any;
  loggedInCompanyID: any;
  loggedInUserCompanyID: any;
  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      alert('No token found in URL');
      return;
    }

    this.httpService.callGetService(`${this.config.autoLogin}?token=${token}`).subscribe((data: any) => {
      if (data?.accessToken) {
        console.log('data..........', data?.roles);
        let superManager = 'NOManager';

        const hasHOD = data?.roles.some((role: any) => role.displayName === 'HOD');
        const hasManager = data?.roles.some((role: any) => role.displayName === 'Manager');

        if (hasHOD && hasManager) {
          superManager = 'HODManager';
        }
        sessionStorage.setItem('HODManager', superManager);

        sessionStorage.setItem('currentToken', data?.accessToken);
        sessionStorage.setItem('autoLogin', 'autoLogin');
        sessionStorage.setItem('department', data?.userProfile?.department);
        sessionStorage.setItem('userCompanyHr', data.userProfile.userCompanyHr);
        sessionStorage.setItem('refreshToken', data?.refreshToken);
        sessionStorage.setItem('loggedInUserName', data?.userProfile?.firstName + ' ' + data?.userProfile?.lastName);
        sessionStorage.setItem('loggedInUserId', data?.userProfile?.id);
        this.userRole = this.encryptionService.encryptData(data?.roles[0]?.displayName);
        sessionStorage.setItem('loggedInUserRole', this.userRole);
        sessionStorage.setItem('userEmail', data?.userProfile?.email);
        sessionStorage.setItem('empCode', data?.userProfile?.empCode);
        sessionStorage.setItem('isDottedManager', data?.userProfile?.isDottedManager);
        this.loggedInCompanyID = this.encryptionService.encryptData(String(data?.userProfile?.companyId));
        sessionStorage.setItem('loggedInUserCompanyID', this.loggedInCompanyID);
        this.loggedInUserCompanyID = data?.userProfile?.companyId;
        sessionStorage.setItem('loggedInUserRoles', JSON.stringify(data?.roles));
        const role = data.roles[0].displayName.toLowerCase();
        if (['super admin', 'phi admin', 'phi finance & accounts'].includes(role)) {
          sessionStorage.setItem('subModuleButtonColor', '#393186');
          sessionStorage.setItem('buttonColorName', '#F6921E');
          sessionStorage.setItem('moduleNameColor', '#F6921E');
          this.router.navigate(['/home/companies']);
        } else {
          this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {
            sessionStorage.setItem('loggedInUserCompanyName', data?.data?.companyName);
            sessionStorage.setItem('loggedInCompanyData', JSON.stringify(data?.data));
            sessionStorage.setItem('subModuleButtonColor', data?.data?.subModuleButtonColor);
            sessionStorage.setItem('buttonColorName', data?.data?.buttonColorName);
            sessionStorage.setItem('moduleNameColor', data?.data?.moduleNameColor);
            sessionStorage.setItem('dashboardColorName', data?.data?.dashboardColorName);
            sessionStorage.setItem('companyLogo', data?.data?.logo);
            this.fiscalYear = this.encryptionService.encryptData(data?.data?.fiscalYear);
            sessionStorage.setItem('loggedInCompanyFiscalyear', this.fiscalYear);
            sessionStorage.setItem('loggedInCompanyIndustryName', data?.data?.industry?.industryName);
            sessionStorage.setItem('loggedInCompanyIndustryID', data?.data?.industry?.id);
            sessionStorage.setItem('loggedInCompanyMDCode', data?.data?.employeeIdOfMD);
            if (sessionStorage.getItem('empCode') == data?.data?.employeeIdOfMD) sessionStorage.setItem('loggedInUserIsMD', 'true');

            console.log(this.loggedInUserCompanyID);
            if (this.loggedInUserCompanyID) {
              const companyID = Number(this.loggedInUserCompanyID);
              console.log(companyID);

              // if (companyID) {
              if (companyID && (companyID == 32867 || companyID == 32869)) {
                this.router.navigate(['/home/hrportal/competency']);
              } else {
                this.router.navigate(['/home/hrportal/dwmplus']);
              }
              // } else {
              //   this.router.navigate(['/home/hrportal/dwmplus']);
              // }
            }
          });
          // setTimeout(() => {
          //   if (this.loggedInUserCompanyID) {
          //     const companyID = Number(this.loggedInUserCompanyID);
          //     console.log(companyID);

          //     if (companyID) {
          //       if (companyID == 32867 || companyID == 32869) {
          //         this.router.navigate(['/home/hrportal/competency']);
          //       } else {
          //         this.router.navigate(['/home/hrportal/dwmplus']);
          //       }
          //     }
          //   }
          // }, 500);
        }
      } else {
        alert(data?.data || 'Invalid token');
      }
    });
  }
}
